import { Nav } from "@/classes/Nav";
import gsap from "@lib/gsap";
import hey from "@lib/hey";

export default function (element: HTMLElement, dataset: any) {
  const nav = new Nav();

  const navItems = element.querySelectorAll(
    "[data-nav-desktop-main-group] [data-nav-item]"
  );

  navItems.forEach((item) => {
    item.classList.add("transparent");
  });

  hey.on("PRELOADER_COMPLETE", (data: any) => {
    nav.init();
  });
}
